import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  flags = 'flags',
  resolverTest = 'resolverTest',
  flag = 'flag',
  flagsTools = 'flagsTools',
}

enum ExternalRoutesIds {
  workflow = 'workflow',
  workflowInstance = 'workflowInstance',
  clients = 'clients',
  clientSchema = 'clientSchema',
  client = 'client',
  materializedSegments = 'materializedSegments',
  segments = 'segments',
  segment = 'segment',
  labels = 'labels',
  github = 'github',
  recordingsExplorer = 'recordingsExplorer',
  managedCodingAgent = 'managedCodingAgent',
}

// root route
export const flagsRouteRef = createPageRoute({
  id: 'flag-index',
  page: { title: 'Flags' },
});

export const rootRouteRef = flagsRouteRef;

// sub-routes within the plugin
export const resolverTesterRouteRef = createSubRouteRef({
  id: RoutesIds.resolverTest,
  parent: rootRouteRef,
  path: '/resolver-test',
});

export const flagRouteRef = createPageRoute({
  id: RoutesIds.flag,
  route: { parent: rootRouteRef, path: '/:id' },
  page: { title: 'Flag' },
});

export const flagsToolsRouteRef = createSubRouteRef({
  id: RoutesIds.flagsTools,
  parent: rootRouteRef,
  path: '/tools',
});

// external routes to other plugins
export const workflowRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflow,
  params: ['workflow'],
  optional: true,
});

export const workflowInstanceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflowInstance,
  params: ['workflow', 'id'],
  optional: true,
});

export const clientsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.clients,
  optional: true,
});

export const clientSchemaRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.clientSchema,
  optional: true,
});

export const clientRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.client,
  params: ['id'],
  optional: true,
});

export const materializedSegmentsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.materializedSegments,
  optional: true,
});

export const segmentsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.segments,
});

export const segmentRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.segment,
  params: ['id'],
});

export const labelsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.labels,
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

export const recordingsExplorerRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.recordingsExplorer,
  optional: true,
});

export const managedCodingAgentRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.managedCodingAgent,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  flags: flagsRouteRef,
  resolverTest: resolverTesterRouteRef,
  flag: flagRouteRef,
  flagsTools: flagsToolsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other plugins
  workflow: workflowRouteRef,
  workflowInstance: workflowInstanceRouteRef,
  clients: clientsRouteRef,
  clientSchema: clientSchemaRouteRef,
  client: clientRouteRef,
  materializedSegments: materializedSegmentsRouteRef,
  segments: segmentsRouteRef,
  segment: segmentRouteRef,
  labels: labelsRouteRef,
  github: githubRouteRef,
  recordingsExplorer: recordingsExplorerRouteRef,
  managedCodingAgent: managedCodingAgentRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
